import { render } from "./Screenshots.vue?vue&type=template&id=2dc59740"
import script from "./Screenshots.vue?vue&type=script&lang=ts"
export * from "./Screenshots.vue?vue&type=script&lang=ts"
script.render = render

export default script